import { put, call, takeLatest } from 'redux-saga/effects';
// components
import { closeLoader, openLoader } from '../../components/loader/actions';
// helpers/constants
import * as G from '../../helpers';
import * as GC from '../../constants';
// utilities
import { sendRequest } from '../../utilities/http';
import endpointsMap from '../../utilities/endpoints';
// feature fleet-profile-simple
import * as A from './actions';
//////////////////////////////////////////////////

function* getDriverProfileInfoRequest({ payload }) {
  try {
    yield put(openLoader());

    const endpoint = endpointsMap.driverCardsInfo(payload);

    const res = yield call(sendRequest, 'get', endpoint);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getDriverProfileInfoSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'getDriverProfileInfoRequest');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getDriverProfileInfoRequest');
  } finally {
    yield put(closeLoader());
  }
}

function* getDriverCertificatesRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: {
        [GC.FIELD_DRIVER_GUID]: payload,
      },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.driverCertificationList, options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getDriverCertificatesSuccess({ certificates: data, [GC.FIELD_DRIVER_GUID]: payload }));
    } else {
      yield call(G.handleFailResponse, res, 'getDriverCertificatesRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getDriverCertificatesRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getDriverFuelCardsRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: {
        [GC.FIELD_DRIVER_GUID]: payload,
      },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.fleetDriverExternalFuelCards, options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getDriverFuelCardsSuccess({ fuelCards: data, [GC.FIELD_DRIVER_GUID]: payload }));
    } else {
      yield call(G.handleFailResponse, res, 'getDriverFuelCardsRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getDriverFuelCardsRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* toggleDriverFuelCardRequest({ payload }) {
  try {
    const { guid, value, driverGuid } = payload;

    const params = { [GC.FIELD_DRIVER_GUID]: driverGuid };

    const endpoint = G.ifElse(
      G.isTrue(value),
      endpointsMap.fleetDriverExternalEnableByGuid,
      endpointsMap.fleetDriverExternalDisableByGuid,
    )(guid);

    const res = yield call(sendRequest, 'put', endpoint, { params });

    const { status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.toggleDriverFuelCardSuccess(payload));

      yield call(G.showToastrMessage, 'success', 'messages:success:200-201');
    } else {
      yield call(G.handleFailResponse, res, 'toggleDriverFuelCardRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'toggleDriverFuelCardRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getDriverAvailabilityStatusRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: {
        [GC.FIELD_DRIVER_GUID]: payload,
      },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.driverAvailabilityStatus, options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getDriverAvailabilityStatusSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'getDriverAvailabilityStatusRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getDriverAvailabilityStatusRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getAssignInfoRequest({ payload }) {
  try {
    yield put(openLoader());

    const { driverGuid, profileType } = payload;

    const res = yield call(sendRequest, 'get', endpointsMap.getAssignInfoEndpoint(driverGuid));

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getAssignInfoSuccess({ ...data, profileType }));
    } else {
      yield call(G.handleFailResponse, res, 'getAssignInfoRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getAssignInfoRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

// truck
function* getTruckLatestKnownLocationRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: { [GC.FIELD_TRUCK_GUID]: payload },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.truckLatestLocation, options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getTruckLatestKnownLocationSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'getTruckLatestKnownLocationRequest fail');
    }
  } catch (error) {
    yield call(G.handleException, error, 'getTruckLatestKnownLocationRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getTruckProfileRequest({ payload }) {
  try {
    yield put(openLoader());

    const res = yield call(sendRequest, 'get', endpointsMap.getCurrentTruckEndpoint(payload));

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      const { driverGuid } = data;

      yield put(A.getTruckProfileSuccess(data));

      if (G.isNotNil(driverGuid)) yield call(getAssignInfoRequest, { payload: { driverGuid, profileType: 'truck' } });

      yield call(getTruckLatestKnownLocationRequest, { payload });
    } else {
      yield call(G.handleFailResponse, res, 'handleGetTruckRequestSaga fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'handleGetTruckRequestSaga exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getTruckDocumentListRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: {
        primaryObjectGuid: payload,
      },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.truckDocList, options);

    const { data, status } = res;
    if (G.isResponseSuccess(status)) {
      yield put(A.getTruckDocumentListSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'getTruckDocumentListRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getTruckDocumentListRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

// trailer
function* getTrailerLatestKnownLocationRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: { [GC.FIELD_TRAILER_GUID]: payload },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.trailerLatestLocation, options);

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      yield put(A.getTrailerLatestKnownLocationSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'getTrailerLatestKnownLocationRequest fail');
    }
  } catch (error) {
    yield call(G.handleException, error, 'getTrailerLatestKnownLocationRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getTrailerProfileRequest({ payload }) {
  try {
    yield put(openLoader());

    const res = yield call(sendRequest, 'get', endpointsMap.getCurrentTrailerEndpoint(payload));

    const { data, status } = res;

    if (G.isResponseSuccess(status)) {
      const { driverGuid } = data;

      yield put(A.getTrailerProfileSuccess(data));

      if (G.isNotNil(driverGuid)) yield call(getAssignInfoRequest, { payload: { driverGuid, profileType: 'trailer' } });

      yield call(getTrailerLatestKnownLocationRequest, { payload });
    } else {
      yield call(G.handleFailResponse, res, 'getTrailerProfileRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getTrailerProfileRequest exception');
  } finally {
    yield put(closeLoader());
  }
}

function* getTrailerDocumentListRequest({ payload }) {
  try {
    yield put(openLoader());

    const options = {
      params: {
        primaryObjectGuid: payload,
      },
    };

    const res = yield call(sendRequest, 'get', endpointsMap.trailerDocList, options);

    const { data, status } = res;
    if (G.isResponseSuccess(status)) {
      yield put(A.getTrailerDocumentListSuccess(data));
    } else {
      yield call(G.handleFailResponse, res, 'getTrailerDocumentListRequest fail');
    }
  } catch (error) {
    yield call(G.showToastrMessage, 'error', 'messages:error:unknown');
    yield call(G.handleException, error, 'getTrailerDocumentListRequest exception');
  } finally {
    yield put(closeLoader());
  }
}


function* fleetProfileSimpleWatcherSaga() {
  yield takeLatest(A.getDriverFuelCardsRequest, getDriverFuelCardsRequest);
  yield takeLatest(A.getDriverProfileInfoRequest, getDriverProfileInfoRequest);
  yield takeLatest(A.toggleDriverFuelCardRequest, toggleDriverFuelCardRequest);
  yield takeLatest(A.getDriverCertificatesRequest, getDriverCertificatesRequest);
  yield takeLatest(A.getDriverAvailabilityStatusRequest, getDriverAvailabilityStatusRequest);
  // truck
  yield takeLatest(A.getTruckProfileRequest, getTruckProfileRequest);
  yield takeLatest(A.getTruckDocumentListRequest, getTruckDocumentListRequest);
  // trailer
  yield takeLatest(A.getTrailerProfileRequest, getTrailerProfileRequest);
  yield takeLatest(A.getTrailerDocumentListRequest, getTrailerDocumentListRequest);
}

export default fleetProfileSimpleWatcherSaga;
